import { useCallback, useEffect, useState } from "react"

import { isKeyboardTypingTarget } from "@/lib/isKeyboardTypingTarget"

interface UseOrgSwitcherModalReturn {
  isOpen: boolean
  openModal: () => void
  closeModal: () => void
}

export const useOrgSwitcherModal = (): UseOrgSwitcherModalReturn => {
  const [isOpen, setIsOpen] = useState(false)

  const openModal = useCallback(() => {
    setIsOpen(true)
  }, [])

  const closeModal = useCallback(() => {
    setIsOpen(false)
  }, [])

  // Global keyboard shortcuts: cmd+ctrl+o or cmd+option+o
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (isKeyboardTypingTarget(event.target)) {
        return
      }

      if (
        event.metaKey &&
        event.ctrlKey !== event.altKey &&
        !event.shiftKey &&
        event.key.toLowerCase() === "o"
      ) {
        event.preventDefault()
        openModal()
      }
    }

    document.addEventListener("keydown", handleKeyDown)
    return () => document.removeEventListener("keydown", handleKeyDown)
  }, [openModal])

  return {
    isOpen,
    openModal,
    closeModal,
  }
}
